import React, { useState, useEffect, Fragment } from 'react';
import { Button, Col, Row } from 'reactstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const VisualOptions = ({ }) => {

    const [receiptsZeroData, setReceiptsZeroData] = useState(false);
    const [invoiceShowMoreData, setInvoiceShowMoreData] = useState(false);
    const [speechTeraphyV1Data, setSpeechTeraphyV1Data] = useState(false);
    const [abreviattureAgenda, setAbreviattureAgenda] = useState(false);
    const [receiptsCancelInCreditNote, setReceiptsCancelInCreditNote] = useState(false);
    const [anamnesisProcedure, setAnamnesisProcedure] = useState(false);
    const [showInfoFeminine, setShowInfoFeminine] = useState(false);
    const [showSpecialReq, setShowSpecialReq] = useState(false);
    const [showFallingRisks, setShowFallingRisks] = useState(false);
    const [showPDFCertAdmission, setShowPDFCertAdmission] = useState(false);
    const [verifyPaymentControlServices, setVerifyPaymentControlServices] = useState(false);
    const [numDaysToValidatePayment, setNumDaysToValidatePayment] = useState(null);
    const [showAlergiesInHcAdm, setShowAlergiesInHcAdm] = useState(false);
    const [manageCalendar, setManageCalendar] = useState(false);


    useEffect(() => {
        getVisualOptions();
    }, []);

    const getVisualOptions = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}clinica/consultar-opciones-visuales`, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {
            if (data.clinica != null && data.clinica != undefined) {
                setReceiptsZeroData(data.clinica.recibos_cero);
                setInvoiceShowMoreData(data.clinica.factura_ver_mas);
                setSpeechTeraphyV1Data(data.clinica.fonoaudiologia_v1);
                setAbreviattureAgenda(data.clinica.abreviatura_pdf_agenda);
                setReceiptsCancelInCreditNote(data.clinica.anulacion_recibos_nota);
                setAnamnesisProcedure(data.clinica.anamnesis_historia);
                setShowInfoFeminine(data.clinica.info_femenina);
                setShowSpecialReq(data.clinica.solicitar_req_especiales);
                setShowFallingRisks(data.clinica.solicitar_riesdo_caida);
                setShowPDFCertAdmission(data.clinica.mostrar_cert_admision);
                setVerifyPaymentControlServices(data.clinica.cobro_consulta_control);
                setNumDaysToValidatePayment(data.clinica.nro_dias_validar_cobro_cita);
                setShowAlergiesInHcAdm(data.clinica.ver_alergias_listado_hc_adm)
                setManageCalendar(data.clinica.administrar_agenda);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const updateVisualOptions = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}clinica/actualizar-opciones-visuales`, {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                recibos_cero: receiptsZeroData,
                factura_ver_mas: invoiceShowMoreData,
                fonoaudiologia_v1: speechTeraphyV1Data,
                abreviatura_pdf_agenda: abreviattureAgenda,
                anulacion_recibos_nota: receiptsCancelInCreditNote,
                anamnesis_historia: anamnesisProcedure,
                info_femenina: showInfoFeminine,
                solicitar_req_especiales: showSpecialReq,
                solicitar_riesdo_caida: showFallingRisks,
                mostrar_cert_admision: showPDFCertAdmission,
                cobro_consulta_control: verifyPaymentControlServices,
                nro_dias_validar_cobro_cita: parseInt(numDaysToValidatePayment),
                ver_alergias_listado_hc_adm: showAlergiesInHcAdm,
                administrar_agenda: manageCalendar
            })
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Data');
            }
        }).then(data => {
            alert("Parametrizaciones Visuales Actualizadas correctamente");
        }).catch((error) => {
            console.log(error);
        });
    }

    return (
        <Fragment>
            <div className="card__title">
                <h5 className="bold-text">Visualizaciones</h5>
                <h5 className="subhead">Aqui puede Parametrizar las Visualizaciones del Sistema en algunos Modulos</h5>
            </div>

            <Row>
                <Col md={3}>
                    <TextField
                        select
                        label="Consecutivo de Recibos en 0"
                        value={receiptsZeroData}
                        onChange={(event) => {
                            setReceiptsZeroData(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Visualización de Pacientes en Facturas"
                        value={invoiceShowMoreData}
                        onChange={(event) => {
                            setInvoiceShowMoreData(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Historia Clinica Fonoaudiologia V1"
                        value={speechTeraphyV1Data}
                        onChange={(event) => {
                            setSpeechTeraphyV1Data(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Usar abreviaturas en Documentos de la Agenda?"
                        value={abreviattureAgenda}
                        onChange={(event) => {
                            setAbreviattureAgenda(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <TextField
                        select
                        label="Cancelar Recibos de Caja? (Nota Crédito)"
                        value={receiptsCancelInCreditNote}
                        onChange={(event) => {
                            setReceiptsCancelInCreditNote(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Visualizacion de Anamnesis para Procedimientos?"
                        value={anamnesisProcedure}
                        onChange={(event) => {
                            setAnamnesisProcedure(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Solicitar información Femenina"
                        value={showInfoFeminine}
                        onChange={(event) => {
                            setShowInfoFeminine(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>

                <Col md={3}>
                    <TextField
                        select
                        label="Solicitar Requerimientos Especiales"
                        value={showSpecialReq}
                        onChange={(event) => {
                            setShowSpecialReq(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <TextField
                        select
                        label="Solicitar Riesgo de Caida"
                        value={showFallingRisks}
                        onChange={(event) => {
                            setShowFallingRisks(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Mostrar Certificado de Admisión"
                        value={showPDFCertAdmission}
                        onChange={(event) => {
                            setShowPDFCertAdmission(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Cobrar Consultas de Control o Seguimiento?"
                        value={verifyPaymentControlServices}
                        onChange={(event) => {
                            setVerifyPaymentControlServices(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        label="Número días a validar Cita de Control"
                        value={numDaysToValidatePayment}
                        onChange={(event) => {
                            setNumDaysToValidatePayment(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <TextField
                        select
                        label="Ver alergias en listado de HC y admsiones"
                        value={showAlergiesInHcAdm}
                        onChange={(event) => {
                            setShowAlergiesInHcAdm(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}>
                    <TextField
                        select
                        label="Administrar horarios Agenda"
                        value={manageCalendar}
                        onChange={(event) => {
                            setManageCalendar(event.target.value);
                        }}
                        style={{ margin: 10, width: '100%' }}
                        className="medical-material-form__field"
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={true}>
                            SI
                        </MenuItem>
                        <MenuItem key={1} value={false}>
                            NO
                        </MenuItem>
                    </TextField>
                </Col>
                <Col md={3}></Col>
                <Col md={3}>
                    <div className='flex-end-elem' >
                        <div>
                            <Button
                                size='sm'
                                onClick={() => {
                                    updateVisualOptions();
                                }}
                                className="btn btn-primary text-white"
                            >
                                Configurar
                            </Button>

                        </div>
                    </div>
                </Col>

            </Row>
        </Fragment>)
};

export default VisualOptions;